var indexOf = [].indexOf;

import humanize from 'helpers/humanize';

import random from 'helpers/random';

angular.module('gym.components').controller('ManageFilterConditionsCtrl', ["$scope", "$modalInstance", "$filter", "report", "reports", "filter", "inReportOptions", "inReportFilterAvailable", "displayInReportFilterDescription", function($scope, $modalInstance, $filter, report, reports, filter, inReportOptions, inReportFilterAvailable, displayInReportFilterDescription) {
  var base, relativeDateReady, userValueReady;
  $scope.report = report;
  $scope.reports = reports;
  $scope.filter = filter;
  $scope.displayInReportFilterDescription = displayInReportFilterDescription;
  (base = $scope.filter).join_filters_with || (base.join_filters_with = 'join_filters_with_and');
  $scope.relativeDateId = random();
  $scope.periods = ['days', 'weeks', 'months', 'years'];
  $scope.multipliers = ['from_now', 'ago'];
  $scope.displayAddConditionForm = function() {
    return $scope.newFilter = {};
  };
  $scope.displaySectionName = function(section) {
    return $scope.report.column_section_name_map[section] || humanize(section);
  };
  $scope.cancelNewFilter = function() {
    $scope.confirmChangesMessageVisible = false;
    return $scope.newFilter = void 0;
  };
  $scope.deleteSubFilter = function(index) {
    filter = $scope.filter.report_sub_filters_attributes[index];
    if (filter.id) {
      return filter._destroy = 1;
    } else {
      return $scope.filter.report_sub_filters_attributes.splice(index, 1);
    }
  };
  $scope.hasSubFilters = function() {
    return _.find($scope.filter.report_sub_filters_attributes, function(filter) {
      return !filter._destroy;
    });
  };
  $scope.addFilter = function() {
    var base1, report_filter;
    filter = $scope.newFilter;
    (base1 = $scope.filter).report_sub_filters_attributes || (base1.report_sub_filters_attributes = []);
    report_filter = filter.column.inReport ? {
      operator: filter.column.operator,
      operator_label: humanize(filter.column.operator),
      user_value: filter.user_value,
      database_value_label: 'Contact',
      database_value: 'contacts:id'
    } : {
      report_filter_id: filter.id,
      database_value: filter.column.form_field_id || filter.column.table_and_column || filter.column.unique_id,
      database_value_label: filter.column.label,
      data_type: filter.column.data_type,
      operator: filter.condition[1],
      operator_label: filter.condition[0],
      user_value: filter.user_value,
      relative_date: filter.relative_date,
      multiplier: filter.multiplier,
      period: filter.period,
      number: filter.number
    };
    $scope.filter.report_sub_filters_attributes.push(report_filter);
    $scope.newFilter = void 0;
    return $scope.confirmChangesMessageVisible = false;
  };
  $scope.joinFilterLabel = function() {
    if ($scope.filter.join_filters_with === 'join_filters_with_or') {
      return 'OR';
    } else {
      return 'AND';
    }
  };
  $scope.addCondition = function() {
    if (!$scope.filter.report_sub_filters_attributes) {
      $scope.filter.report_sub_filters_attributes = [];
    }
    return $scope.filter.report_sub_filters_attributes.push({});
  };
  $scope.availableColumns = function() {
    var available, availableColumns, columns, forbiddenForFiltration, ref, ref1, ref2;
    columns = (ref = $scope.report.report_columns_options) != null ? ref[(ref1 = $scope.newFilter) != null ? ref1.section : void 0] : void 0;
    forbiddenForFiltration = ['Contact ID'];
    available = _.filter(columns, function(column) {
      var ref2;
      return ref2 = column.label, indexOf.call(forbiddenForFiltration, ref2) < 0;
    });
    availableColumns = _.map(available, function(val) {
      return val;
    });
    if (inReportFilterAvailable && ((ref2 = $scope.newFilter) != null ? ref2.section : void 0) === 'contact') {
      return inReportOptions.concat(availableColumns);
    } else {
      return availableColumns;
    }
  };
  $scope.onColumnChanged = function() {
    $scope.newFilter.condition = '';
    return $scope.newFilter.relative_date = false;
  };
  $scope.onConditionChanged = function() {
    $scope.newFilter.user_value = '';
    $scope.newFilter.number = '';
    $scope.newFilter.relative_date = false;
    $scope.newFilter.multiplier = '';
    return $scope.newFilter.period = '';
  };
  $scope.onRelativeChange = function() {
    var base1, base2;
    if ($scope.newFilter.relative_date) {
      $scope.newFilter.user_value = '';
      (base1 = $scope.newFilter).relative_date || (base1.relative_date = false);
      (base2 = $scope.newFilter).multiplier || (base2.multiplier = $scope.multipliers[0]);
      return $scope.newFilter.period = 'months';
    }
  };
  $scope.requireUserValue = function() {
    var blankValueConditions, ref, ref1, ref2;
    blankValueConditions = ['Is blank', 'Is not blank'];
    return ref = (ref1 = $scope.newFilter) != null ? (ref2 = ref1.condition) != null ? ref2[0] : void 0 : void 0, indexOf.call(blankValueConditions, ref) < 0;
  };
  relativeDateReady = function() {
    filter = $scope.newFilter;
    return filter.relative_date && (($filter('filterInt')(filter.number) >= 0) && filter.period && filter.multiplier);
  };
  userValueReady = function() {
    var ref;
    return !$scope.requireUserValue() || ((ref = $scope.newFilter.user_value) != null ? ref.toString() : void 0) || relativeDateReady();
  };
  $scope.isFilterReady = function() {
    var ref, ref1, ref2;
    if ((ref = $scope.newFilter) != null ? (ref1 = ref.column) != null ? ref1.inReport : void 0 : void 0) {
      return userValueReady();
    } else {
      return ((ref2 = $scope.newFilter) != null ? ref2.column : void 0) && $scope.newFilter.condition && userValueReady();
    }
  };
  $scope.submit = function() {
    if ($scope.newFilter) {
      $scope.confirmChangesMessageVisible = true;
      return;
    }
    return $modalInstance.close($scope.filter);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
